// import { io } from "socket.io-client";

function Watcher() {
    const socket = io('https://logger.shocklogic.com');

    return {
        socket,
        pathname: document.location.pathname,
        payload: {
            Client_Id: vl.clientId,
            Project_Id: vl.projectId,
            Person_Id: vl.person.personId,
            User_Agent: navigator.userAgent,
        },
        getPath: function getPath(str) {
            return str.split("/").slice(3).join("/").slice(0,-1)
        },
        watch: function(elements) {
            elements.forEach(element => {
                if(element.hasOwnProperty('waitFor')) {
                    const awaiter = setInterval(function(){
                        if ($(element.waitFor).length > 0) {
                            $(element.selector).on(element.event, element.watch);
                            clearInterval(awaiter);
                        }
                    }, 1000);
                } else {
                    $(element.selector).on(element.event, element.watch);
                }
            })
        },
        emit: (action, data) => {
            socket.emit(action, data);
            console.log({emit: data});
            console.log('connected', socket.connected)
            console.log(socket.emit(action, data))
        },
    }
}

export default Watcher;
